import React from 'react';
import { CheckCircle, XCircle, HelpCircle, X } from 'lucide-react';

export const ToastContainer = ({ toasts }) => (
  <div className="fixed top-4 right-4 z-50 space-y-2 max-w-sm w-full">
    {toasts.map(toast => (
      <div
        key={toast.id}
        className={`px-4 py-3 rounded-xl shadow-2xl flex items-center space-x-3 animate-in slide-in-from-right duration-300 ${
          toast.type === 'success' ? 'bg-green-500 text-white' :
          toast.type === 'error' ? 'bg-red-500 text-white' :
          toast.type === 'info' ? 'bg-blue-500 text-white' :
          'bg-gray-800 text-white'
        }`}
      >
        {toast.type === 'success' && <CheckCircle size={20} className="shrink-0" />}
        {toast.type === 'error' && <XCircle size={20} className="shrink-0" />}
        {toast.type === 'info' && <HelpCircle size={20} className="shrink-0" />}
        <span className="flex-1 text-sm font-medium">{toast.message}</span>
        <button
          onClick={() => toast.onClose?.()}
          className="shrink-0 hover:opacity-70 transition-opacity"
        >
          <X size={16} />
        </button>
      </div>
    ))}
  </div>
);


